(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('CareTeamSpecialty', CareTeamSpecialty);

    CareTeamSpecialty.$inject = ['$resource'];

    function CareTeamSpecialty ($resource) {
        var resourceUrl =  'api/care-team-specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
